import React from 'react';
import { cssMap } from '@atlaskit/css';
import { Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { useVerticalMode } from '../../controllers/feature-context.tsx';

export const JQLBuilderContainer = ({ children }: { children: React.ReactNode }) => {
	const verticalMode = useVerticalMode();

	if (verticalMode) {
		return (
			<Stack as="ul" xcss={jqlBuilderContainerStyles.fieldList}>
				{children}
			</Stack>
		);
	}

	return children;
};

const jqlBuilderContainerStyles = cssMap({
	fieldList: {
		paddingInline: token('space.0'),
		paddingTop: token('space.150'),
		paddingBlockEnd: token('space.300'),
		width: '100%',
	},
});
